/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_UsedInputs */

const en_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used`)
};

const es_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usado`)
};

const fr_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Occasion`)
};

const de_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebraucht`)
};

const ja_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中古`)
};

const zh_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二手`)
};

const ar_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستعمل`)
};

const id_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekas`)
};

const it_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usato`)
};

const ru_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Б/У`)
};

const pt_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usado`)
};

const ko_val_used = /** @type {(inputs: Val_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중고`)
};

/**
* | output |
* | --- |
* | "Used" |
*
* @param {Val_UsedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_used = /** @type {((inputs?: Val_UsedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_UsedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_used(inputs)
	if (locale === "es") return es_val_used(inputs)
	if (locale === "fr") return fr_val_used(inputs)
	if (locale === "de") return de_val_used(inputs)
	if (locale === "ja") return ja_val_used(inputs)
	if (locale === "zh") return zh_val_used(inputs)
	if (locale === "ar") return ar_val_used(inputs)
	if (locale === "id") return id_val_used(inputs)
	if (locale === "it") return it_val_used(inputs)
	if (locale === "ru") return ru_val_used(inputs)
	if (locale === "pt") return pt_val_used(inputs)
	return ko_val_used(inputs)
});